import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';

const customApp: App = {
  appId: 'custom',
};

export default customApp;